var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/nodes/youtube.ts
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-flex";
import "@adornis/chemistry/elements/components/x-icon";
import "@adornis/forms/x-input";
import { html } from "lit";
import { customElement } from "lit/decorators.js";
import { YOUTUBE_KEY, YOUTUBE_SCHEMA } from "../../schema/nodes/youtube.js";
import { BuildifyLitElement } from "../BuildifyLitElement.js";
import { runInsertNode } from "../helper/runInsertNode.js";
import { MenuItemGroup } from "../types.js";
import { isNodeSelection } from "../util.js";
var editor = ({ content, contentController, controllerBaseKeyPath, host }) => {
  return html`
    <x-flex space="md">
      <x-input placeholder="Youtube ID" ${contentController.field(...controllerBaseKeyPath, "youtubeID")}></x-input>
    </x-flex>
  `;
};
var youtube = () => ({
  node: {
    name: YOUTUBE_KEY,
    schema: YOUTUBE_SCHEMA()
  },
  menuItems: [
    {
      group: MenuItemGroup.MEDIA,
      label: "YouTube",
      icon: "youtube_activity",
      run: (view) => runInsertNode(YOUTUBE_KEY)(view.state, view),
      shouldVisualize: (view) => {
        return !isNodeSelection(view.state.selection);
      }
    }
  ],
  editor
});
var NodeYoutube = class extends BuildifyLitElement {
  content({ content, mode }) {
    if (mode === "print") {
      return html`<x-link href=${`https://www.youtube.com/watch?v=${content?.youtubeID ?? ""}`} target="_blank">
        <x-flex horizontal crossaxis-center space="sm">
          <x-icon> youtube_activity </x-icon>
          <x-text>https://www.youtube.com/watch?v=${content?.youtubeID ?? ""}</x-text>
        </x-flex>
      </x-link>`;
    }
    return html`
      <iframe
        src=${`https://www.youtube.com/embed/${content?.youtubeID ?? ""}`}
        width="100%"
        ${css({ aspectRatio: "16 / 9", borderRadius: "4px" })}
        frameborder="0"
        allow="autoplay; fullscreen"
        allowfullscreen
      ></iframe>
    `;
  }
};
NodeYoutube = __decorateClass([
  customElement("node-youtube")
], NodeYoutube);
export {
  NodeYoutube,
  youtube
};
